import {Injectable} from "@angular/core";
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "./auth.service";
/**
 * Created by nijin on 7/8/17.
 */
@Injectable()
export class SiteGuard implements CanActivate{

  constructor(private router: Router,
              private authService: AuthService){

  }

  canActivate( next: ActivatedRouteSnapshot,
               state: RouterStateSnapshot){

    if(state.url === '/' && this.authService.isLoggedIn()){
      this.router.navigate(['/things']);
      return false;
    };

    return true;

  }
}



// WEBPACK FOOTER //
// ./src/app/auth/site-guard.ts